export default "__VITE_ASSET__ohylsqx3__"